import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import { FaMagnifyingGlass } from "react-icons/fa6";
import TrainingOverviews from "./index";
import ViewTrainingOverview from "./view";
import EditTrainingOverview from "./edit";
import { MODULE_TRAINING_OVERVIEW } from "variables/constants";

const trainingOverviewRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Training Overview",
		basePath: "training-overview",
		mainComponent: <TrainingOverviews />,
	    layout: "/console",	   
	    icon: <FaMagnifyingGlass className="icon-item" />,
	    subTitle:"Training Overview",
	    viewComponent: <ViewTrainingOverview />,
	    createComponent: <EditTrainingOverview />,
	    editComponent: <EditTrainingOverview />,
		level:4,
		moduleId: MODULE_TRAINING_OVERVIEW,
	})
]

export default trainingOverviewRoutes;